import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=38b7425b&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=38b7425b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7425b",
  null
  
)

export default component.exports